export default __webpack_public_path__ + "static/media/aktiv-grotesk-light.33b7e492.woff";